import createReducer from '@shopee/create-reducer';
import { patchArrayWithArray } from '@shopee/array-utils';
import { getNewFetchedRange } from '@shopee/list-redux-util';
import { MART_SEARCH_RESULT_TYPE } from '@shopee/search-common-util';
import { FETCH_MART_SEARCH_ITEMS, COPY_MART_SEARCH_RESULT } from './constants';
import PROGRESS from '@shopee/api-progress';

import type {
  MartSearchItemsStore,
  MartSearchResult,
  MartSearchItemsActionRequested,
  MartSearchItemsActionSuccess,
  MartSearchItemsActionFailed,
  MartCopySearchItemsResult,
} from './types';

const INITIAL_STATE: MartSearchItemsStore = {};

const FALLBACK_RESULT: MartSearchResult = {
  total_count: 0,
  nomore: false,
  adjust: {
    count: 0,
  },
  show_disclaimer: false,
  disclaimer_infos: [],
  items: [],
  query_rewrite: {
    fe_query_write_status: MART_SEARCH_RESULT_TYPE.NORMAL,
    rewrite_keyword: null,
    hint_keywords: null,
    ori_keyword: null,
    ori_totalCount: 0,
    rewrite_type: null,
  },
  nextOffset: 0,
  progress: PROGRESS.INIT,
  fetchedRange: [[0, 0]],
};

export const martSearchItemsReducer = createReducer<MartSearchItemsStore>(
  {
    [FETCH_MART_SEARCH_ITEMS.REQUESTED]: (
      state: MartSearchItemsStore,
      action
    ): MartSearchItemsStore => {
      const {
        payload: { key },
      } = action as MartSearchItemsActionRequested;

      const prevResult = state[key] || FALLBACK_RESULT;
      return {
        ...state,
        [key]: {
          ...prevResult,
          progress: PROGRESS.REQ,
        },
      };
    },
    [FETCH_MART_SEARCH_ITEMS.SUCCESS]: (
      state: MartSearchItemsStore,
      action
    ): MartSearchItemsStore => {
      const {
        payload: { key, limit, offset, result, shouldReset },
      } = action as MartSearchItemsActionSuccess;
      const { items, ...otherResult } = result;
      const nextOffset = limit + offset;
      const prevResult = state[key];
      const currentItems = prevResult.items;
      return {
        ...state,
        [key]: {
          ...prevResult,
          ...otherResult,
          nextOffset,
          progress: PROGRESS.OK,
          fetchedRange: getNewFetchedRange(
            prevResult.fetchedRange,
            offset,
            limit
          ),
          items: patchArrayWithArray(
            shouldReset ? [] : currentItems,
            result.items,
            offset
          ),
        },
      };
    },
    [FETCH_MART_SEARCH_ITEMS.FAILED]: (
      state: MartSearchItemsStore,
      action
    ): MartSearchItemsStore => {
      const {
        payload: { key },
      } = action as MartSearchItemsActionFailed;

      const prevResult = state[key];
      return {
        ...state,
        [key]: {
          ...prevResult,
          progress: PROGRESS.ERR,
        },
      };
    },
    [COPY_MART_SEARCH_RESULT]: (
      state: MartSearchItemsStore,
      action
    ): MartSearchItemsStore => {
      const {
        payload: { key, result },
      } = action as MartCopySearchItemsResult;
      return {
        ...state,
        [key]: result,
      };
    },
  },
  INITIAL_STATE
);
